import { parseEntities } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseTags } from '@/shared/converters/tagConverters';
import DossierStackItem from '../models/DossierStackItem';
import { ABSTRACT_SCHEMA } from './taskConverters';

export const SCHEMA = {
  ...ABSTRACT_SCHEMA,
  id: 'id',
  description: 'memo',
  deadline: (data: any) => parseMoment(data.deadline),
  tags: (data: any) => parseTags(data.tags),
  createdById: 'addedById',
  createdOn: (data: any) => parseMoment(data.addedOn),
};

export function parseDossierStackItems(data: any): Array<DossierStackItem> {
  return parseEntities(data, SCHEMA, DossierStackItem);
}
